import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { hasPendingScrollRestore } from 'hooks/useScrollRestore';

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // A page that saved its own scroll position for this exact URL (the paged
    // /search, on Back) restores it itself; resetting here would land on top
    // of that restore in the same commit.
    if (hasPendingScrollRestore(pathname, search)) return;
    // Target the main content container, not the window
    const mainContent = document.querySelector('.main-page-content');
    if (mainContent) {
      mainContent.scrollTo(0, 0);
    }
    // Also scroll window for pages outside Main layout (public pages)
    window.scrollTo(0, 0);
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
